import React, { useState } from "react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import "./App.css";

function App() {
  const [image, setImage] = useState(null);
  const [favicons, setFavicons] = useState({});

  const sizes = [16, 32, 48, 64, 128, 180, 192, 512];

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const img = new Image();
    img.onload = () => {
      const generated = {};
      sizes.forEach((size) => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, size, size);
        generated[size] = canvas.toDataURL("image/png");
      });
      setFavicons(generated);
    };
    img.src = URL.createObjectURL(file);
    setImage(URL.createObjectURL(file));
  };

  const downloadZip = async () => {
    const zip = new JSZip();
    Object.entries(favicons).forEach(([size, dataUrl]) => {
      const base64 = dataUrl.split(",")[1];
      zip.file(`favicon-${size}x${size}.png`, base64, { base64: true });
    });
    const blob = await zip.generateAsync({ type: "blob" });
    saveAs(blob, "favicons.zip");
  };

  return (
    <div className="App">
      <h1>Favicon Generator</h1>
      <input type="file" accept="image/*" onChange={handleUpload} />

      {image && (
        <>
          <h2>Browser Preview</h2>
          <div className="browser-preview">
            {favicons[32] && (
              <img src={favicons[32]} alt="favicon" className="tab-icon" />
            )}
            <span className="tab-title">My Website</span>
          </div>
        </>
      )}

      {Object.keys(favicons).length > 0 && (
        <button onClick={downloadZip}>Download All Favicons (ZIP)</button>
      )}
    </div>
  );
}

export default App;
